module.exports = __webpack_public_path__ + "img/482-64df8b.png";